import React, { Component } from 'react';
import radium from 'radium';

import batGlove from '../static/images/Block3/batGlove.png';
import block3Card1 from '../static/images/Block3/block3Card1.png';
import block3Card2 from '../static/images/Block3/block3Card2.png';

const styles = {
  wrapper: {
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexDirection: 'column',
    margin: '50px 0',
  },
  titleWrapper: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  titleBlock: {
    width: 270,
    height: 40,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: '#EE8356',
    borderRadius: '20px',
    color: 'white',
    fontWeight: 600,
    letterSpacing: '3px',
    position: 'relative',
    marginBottom: 50,
    '@media (max-width: 414px)': {
      width: 220,
      marginLeft: 10,
    },
  },
  batGlove: {
    width: 100,
    position: 'absolute',
    left: -40,
    bottom: -10,
    '@media (max-width: 414px)': {
      width: 80,
      left: -31,
    },
  },
  cardWrapper: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: '100%',
    overflowX: 'auto',
    '@media (max-width: 970px)': {
      justifyContent: 'flex-start',
      padding: '0 20px',
    },
  },
  cardBlock: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    margin: '0 20px',
    '@media (max-width: 970px)': {
      margin: '0 20px 0 0',
    },
  },
  card: {
    width: 400,
    height: 250,
    borderRadius: 8,
    backgroundColor: '#A2C15A',
    padding: 25,
    display: 'flex',
    flexDirection: 'column',
    position: 'relative',
    textDecoration: 'none',
  },
  cardTitle: {
    margin: 0,
    color: 'white',
    fontWeight: 400,
    textShadow: 'black 0.1em 0.1em 0.8em',
  },
  card1Img: {
    width: 250,
    marginTop: 10,
  },
  card2Img: {
    width: 250,
    position: 'absolute',
    left: 105,
    bottom: 0,
  },
  linkBoxWrapper: {
    width: 60,
    height: 67,
    position: 'absolute',
    right: 25,
    bottom: 20,
    display: 'flex',
    flexDirection: 'column',
    textDecoration: 'none',
  },
  linkBox: {
    width: 60,
    height: 60,
    border: '1.5px solid white',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
  },
  linkText: {
    margin: 0,
    fontSize: 18,
    color: 'white',
    fontWeight: 200,
    letterSpacing: 2,
  },
  linkBoxBottomLine: {
    width: 60,
    height: 7,
    marginTop: 2,
    borderBottom: '6px solid rgb(102, 147, 51)',
    borderRight: 'transparent solid',
  },
  mentionText: {
    color: '#8F5827',
    '@media (max-width: 414px)': {
      fontSize: 13,
    },
  },
};

class Block3 extends Component {
  render() {
    return (
      <div style={styles.wrapper}>
        <div style={styles.titleWrapper}>
          <div style={styles.titleBlock}>
            <img style={styles.batGlove} alt="球棒手套" src={batGlove} />
            人人都有運動魂
          </div>
        </div>
        <div style={styles.cardWrapper} className="scroll">
          <div style={styles.cardBlock}>
            <a
              href="https://homerun2gether-quotations.homeruntaiwan.com/"
              style={styles.card}
              rel="noopener noreferrer"
              target="_blank">
              <h1 style={styles.cardTitle}>
                運動
              </h1>
              <h1 style={styles.cardTitle}>
                教會我的事!
              </h1>
              <img style={styles.card2Img} src={block3Card2} alt="球員" />
              <div style={styles.linkBoxWrapper}>
                <div style={styles.linkBox}>
                  <p style={styles.linkText}>
                    點我
                  </p>
                  <p style={styles.linkText}>
                    前往
                  </p>
                </div>
                <span style={styles.linkBoxBottomLine} />
              </div>
            </a>
            <p style={styles.mentionText}>
              快來表白你的運動魂
            </p>
          </div>
          <div style={styles.cardBlock}>
            <a
              href="https://homerun2gether-game.homeruntaiwan.com/"
              style={styles.card}
              rel="noopener noreferrer"
              target="_blank">
              <h1 style={styles.cardTitle}>
                你是棒球場上的
              </h1>
              <h1 style={styles.cardTitle}>
                那個關鍵人物?
              </h1>
              <img style={styles.card1Img} src={block3Card1} alt="棒球卡" />
              <a style={styles.linkBoxWrapper}>
                <div style={styles.linkBox}>
                  <p style={styles.linkText}>
                    點我
                  </p>
                  <p style={styles.linkText}>
                    前往
                  </p>
                </div>
                <span style={styles.linkBoxBottomLine} />
              </a>
            </a>
            <p style={styles.mentionText}>
              神準心理測驗等你玩
            </p>
          </div>
        </div>
      </div>
    );
  }
}

export default radium(Block3);
